import Vue from 'vue'

const state = {
    imageData: {} // 图片数据，按模块存储
}

const getters = {
    // 获取指定模块的图片列表
    getImageList: (state) => (module) => {
        return state.imageData[module] || []
    },
    // 获取指定模块收藏的图片列表
    getFavoriteImageList: (state) => (module) => {
        const list = state.imageData[module] || []
        return list
            .filter(item => {
                // 检查是否有任何图片被收藏
                return item.images && item.images.some(img => img.isFavorite)
            })
            .map(item => {
                // 只保留被收藏的图片
                return {
                    ...item,
                    images: item.images.filter(img => img.isFavorite)
                }
            })
    }
}

const mutations = {
    // ========== 图片数据管理 ==========
    // 添加图片项
    addImageItem(state, { module, item }) {
        if (!state.imageData) {
            Vue.set(state, 'imageData', {})
        }
        if (!state.imageData[module]) {
            Vue.set(state.imageData, module, [])
        }
        state.imageData[module].unshift(item)
    },
    // 更新图片项
    updateImageItem(state, { module, id, data }) {
        if (state.imageData && state.imageData[module]) {
            const index = state.imageData[module].findIndex(item => item.id === id)
            if (index !== -1) {
                Vue.set(state.imageData[module], index, { ...state.imageData[module][index], ...data })
            }
        }
    },
    // 删除图片项
    deleteImageItem(state, { module, id }) {
        if (state.imageData && state.imageData[module]) {
            const index = state.imageData[module].findIndex(item => item.id === id)
            if (index !== -1) {
                state.imageData[module].splice(index, 1)
            }
        }
    },
    // 设置图片数据
    setImageData(state, { module, data }) {
        if (!state.imageData) {
            Vue.set(state, 'imageData', {})
        }
        Vue.set(state.imageData, module, data)
    }
}

const actions = {}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
